import { createContext } from 'react';

import type { WalletConnectState } from './types';

export const WalletConnectStateContext = createContext({} as WalletConnectState);
